import { type FilterValues } from "components/filters/FilterContext";
import { mapResponseToArtistProfileFilter, mapArtistProfileFilterToInstruction, mapResponseToFavoriteArtistFilter, mapFavoriteArtistFilterToInstruction, mapResponseToKeywordFilter, mapKeywordFilterToInstruction, mapResponseToTagFilter, mapTagFilterToInstruction } from "components/filters/mappingUtils";

export const mapFilterValuesToInstruction = (
  filterSet: server.dto.FilterSets,
  filter: FilterValues,
  page: number,
  perPage: number
): server.dto.PaginatedArtistInstruction => {
  return {
    keyword: mapKeywordFilterToInstruction(filter.keyword),
    onlyFavorite: mapFavoriteArtistFilterToInstruction(filter.favoriteArtists),
    profile: mapArtistProfileFilterToInstruction(filter.artistProfile),
    tags: mapTagFilterToInstruction(filter.tags),
    artistSecurityScope: "limitByUserAccess",
    page,
    perPage,
    cache: filterSet
  };
};

export const mapResponseToFilterValues = (
  response: server.dto.ListArtistFilters,
  values: FilterValues
): Partial<FilterValues> => {
  return {
    keyword: mapResponseToKeywordFilter(response.keyword),
    favoriteArtists: mapResponseToFavoriteArtistFilter(response.onlyFavorite),
    artistProfile: mapResponseToArtistProfileFilter(response.profile),
    tags: mapResponseToTagFilter(response.tags, values.tags)
  };
};
